export const DEFAULT_ROUTE = '/component/inbox';

/**
 * Where leaving onboarding lands when no deep link was preserved (`?next=`)
 */
export const AFTER_SETUP_ROUTE = '/component/getting-started';
